import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import About from "../../components/about/About";

function AboutPage({ setShow }) {
  return (
    <>
      <Helmet>
        <title>About Us | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <About />
    </>
  );
}

export default AboutPage;
